class Quantity {
	static select = $context => $context.select('.quantity');

	constructor($quantity) {
		this.$quantity = $quantity;
		this.timeout_id = null;
		this.max = $quantity.data('max');
		this.bindEvents();
	}

	bindEvents() {
		const self = this;

		self.$quantity.on('click', '.quantity__btn-minus', function () {
			self.setValue(self.getInput().val() - 1);
			self.startTimeoutChange();
		});

		self.$quantity.on('click', '.quantity__btn-plus', function () {
			self.setValue(self.getValue() + 1);
			self.startTimeoutChange();
		});

		self.$quantity.on('change', '.quantity__input', function (e) {
			e.stopPropagation();
			self.refreshValue();
			self.$quantity.trigger('change', {val: self.getValue()});
		});

		self.$quantity.find('.quantity__input').on('keypress keydown keyup', function(e) {
			if(e.keyCode == 13) {
				e.preventDefault();
				$(this).trigger('change');
			}
		});

		self.$quantity.on('update:cart-item', function(e, args){
			self.setValue(args.val);
		});
	}

	getInput() {
		return this.$quantity.find('.quantity__input');
	}

	getValue() {
		return this.handleValue(this.getInput().val());
	}

	setValue(value) {
		const newVal = this.handleValue(value);
		this.getInput().val(newVal);
		this.$quantity.toggleClass('quantity_min-val', (newVal <= 1 && !this.$quantity.hasClass('quantity_delete')));
		if (this.max) {
			this.$quantity.toggleClass('quantity_max-val', (newVal >= this.max));
		}
		this.$quantity.trigger('set_value:quantity');
	}

	startTimeoutChange() {
		clearTimeout(this.timeout_id);
		this.timeout_id = setTimeout(() => {
			this.getInput().trigger('change', {val: this.getValue()});
		}, 500);
	}

	handleValue(value) {
		var handledValue = parseInt(value);

		if (isNaN(handledValue)) {
			handledValue = 1;
		}

		if (this.max) {
			handledValue = Math.min(value, this.max);
		}
		return Math.max(1, handledValue);
	}

	refreshValue() {
		this.setValue(this.getValue());
	}

}

export default () => Component(Quantity.select, $quantity => new Quantity($quantity));
